import { Route, Routes } from "react-router";
import { AppContainer, Root } from "./App.style";
import { Auth } from "./Auth";
import Login from "./auth/login/Login";
import { InternetConnectionErrorHandler } from "./connection/InternetConnectionErrorHandler";
import { ROUTES } from "./routes";

function App() {
  return (
    <InternetConnectionErrorHandler>
      <Root>
        <AppContainer>
          <Routes>
            <Route path="/*" element={<Auth />} />
            <Route path={ROUTES.LOGIN} element={<Login />} />
          </Routes>
        </AppContainer>
      </Root>
    </InternetConnectionErrorHandler>
  );
}

export default App;
